<template>
    <div>
        <div class="content">
            <div class="left-nav">
                <div class="item select navcur">
                    下载中心
                </div>
            </div>
            <div class="right-nav">
                <div class="hotnews_box bgcolor">
                    <div class="main crumbs">
                        <span class="iconfont icon-dingwei"></span>
                        <b>当前位置：</b>
                        <a href="/">首页</a>
                        <a
                            href="javascript:;"
                            class="cur"
                        >下载中心</a>
                    </div>
                </div>
                <div class="data">
                    <div class="tradeList">
                        <div
                            v-for="(item,index) in tableData"
                            :key="index"
                            class="item"
                        >
                            <div class="title">{{item.title}}</div>
                            <div class="download">
                                <div
                                    class="btn"
                                    @click="download(item)"
                                >下载</div>
                            </div>
                        </div>
                    </div>

                    <div class="page">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="total"
                            :page-size="pgData.pagesize"
                            prev-text="上一页"
                            next-text="下一页"
                            @current-change="handleCurrentChange"
                        >
                        </el-pagination>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import CONFIG from '@config/config';
export default {
    data() {
        return {
            nav: [
                {
                    text: '下载中心',
                    value: '100101',
                },
            ],
            tableData: [],
            total: 0,
            pgData: {
                categoryids: 106,
                featurecode: CONFIG.head.planname,
                pageindex: 1,
                pagesize: 10,
                sortname: 'infodate',
                sortorder: 'desc',
            },
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        download(item) {
            window.open(item.urlname);
        },
        handleCurrentChange(val) {
            this.pgData.pageindex = val;
            this.init();
        },
        init() {
            $.get(
                `/web/index/information/getwebinfounion.json`,
                { ...this.pgData },
                (data) => {
                    let tdata = JSON.parse(data);
                    console.log(tdata);
                    this.tableData = tdata.rows;
                    this.total = tdata.total;
                }
            );
        },
    },
};
</script>
<style lang='scss' scoped>
@import '@css/var.scss';
.content {
    padding: 40px 0px 20px 0px;
    display: flex;
    justify-content: space-between;
    min-height: 600px;
}
.left-nav {
    width: 285px;
    .item {
        font-size: 20px;
        cursor: pointer;
        letter-spacing: 1px;
        height: 66px;
        line-height: 66px;
        border-bottom: 1px solid #dcdcdc;
        text-indent: 20px;
    }
}

.right-nav {
    width: 880px;
    font-size: 16px;
    position: relative;
    margin-right: 5px;

    .hotnews_box {
        box-shadow: 1px 0px 5px #dedede;
        line-height: 46px;

        .main {
            margin: 0 auto;
        }

        .crumbs {
            width: auto;
            margin-bottom: 15px;
            span {
                display: inline-block;
                margin-bottom: 2px;
                margin-left: 15px;
                padding: 0 0 0 20px;
                height: 21px;
                background: url(/images/map.jpg) no-repeat center 0;
                vertical-align: middle;
                margin-right: 5px;
            }

            b {
                color: #181818;
                font-weight: normal;
            }

            a {
                padding-right: 20px;
                background: url(/images/r-arrow.png) no-repeat right center;
                color: #181818;
                text-decoration: none;
                font-weight: 400;
                &:last-child {
                    background: 0 0;
                }
            }
            .cur {
                color: #d1171e;
            }
        }
    }

    .data {
        min-height: 600px;
        background: #fff;
        padding: 0px 0px 38px;

        .tradeList {
            margin-top: 20px;
            font-size: 16px;
            .item {
                display: flex;
                justify-content: space-between;
                line-height: 40px;
                margin-bottom: 15px;

                .title {
                    padding: 0px 40px 0px 15px;
                    box-sizing: border-box;
                    position: relative;

                    overflow: hidden; //超出隐藏
                    text-overflow: ellipsis; //文本超出时显示省略号
                    white-space: nowrap; //设置文本不换行
                }

                .download {
                    .btn {
                        padding: 0 20px;
                        display: inline-block !important;
                        background: #cf312a;
                        color: #fff;
                        border-radius: 5px;
                        height: 35px;
                        line-height: 35px;
                        width: 80px;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }
        }

        .page {
            text-align: center;
            margin-top: 20px;
        }
    }
}

.select {
    background: $mainColor;
    color: #fff;
    position: relative;
}

.navcur {
    background: #cf312a url(/images/menubg.png) no-repeat 97% center;
}

::v-deep .el-pagination span:not([class*='suffix']),
.el-pagination button {
    padding: 0px 12px;
}
</style>
